import { IUseWalletStore } from '@/src/store/global/types';
import { TOKEN_GOV_CS, TOKEN_GOV_TN_STR, WEBSITE_TITLE } from '@/src/utils/constants';
import { addAssets, type Assets, type UTxO } from '@lucid-evolution/lucid';
import {
    explainErrorTx,
    GetADATxParams,
    GetTokenGovTxParams,
    isEmulator,
    pushSucessNotification,
    pushWarningNotification,
    showData,
    strToHex,
    TOKEN_ADA_TICKER,
} from '../../Commons';
import { LucidToolsFrontEnd } from '../../lib';

export class UserBtnHandlers {
    // #region front end Btn handlers

    public static async handleBtnGetADATx(
        setProcessingTxMessage: (value: string) => void,
        setProcessingTxHash: (value: string) => void,
        walletStore: IUseWalletStore,
        txParams: GetADATxParams
    ): Promise<boolean> {
        try {
            //--------------------------------------
            setProcessingTxMessage(`Sending ${TOKEN_ADA_TICKER}...`);
            //--------------------------------------
            const { lucid, emulatorDB, walletTxParams } = await LucidToolsFrontEnd.prepareLucidFrontEndForTx(walletStore);
            //--------------------------------------
            const amount = txParams.amount;
            //--------------------------------------
            const valueOf_ADA: Assets = { ['lovelace']: BigInt(amount) };
            console.log(`[User] - Get ADA Tx - valueOf_ADA: ${showData(valueOf_ADA)}`);
            //--------------------------------------
            const uTxOsAtWallet: UTxO[] = walletTxParams.utxos;
            if (uTxOsAtWallet.length === 0) {
                throw `Invalid uTxOsAtWallet length = 0`;
            }
            //--------------------------------------
            const uTxO: UTxO = uTxOsAtWallet[0];
            //--------------------------------------
            const assets: Assets = ((lucid.config().provider as any).ledger[uTxO.txHash + uTxO.outputIndex].utxo as UTxO).assets as Assets;
            ((lucid.config().provider as any).ledger[uTxO.txHash + uTxO.outputIndex].utxo as UTxO).assets = addAssets(assets, valueOf_ADA);
            //--------------------------------------
            pushSucessNotification(`User Get ${TOKEN_ADA_TICKER} Tx`, 'aaff', true);
            //--------------------------------------
            setProcessingTxMessage(`Syncronizing...`);
            //--------------------------------------
            if (isEmulator && emulatorDB !== undefined) {
                // normalmente esto se hace en el submit, pero esta tx es mock y no hay submit
                await LucidToolsFrontEnd.syncEmulatorAfterTx(lucid, emulatorDB);
            }
            //--------------------------------------
            await walletStore.loadWalletData();
            //--------------------------------------
            return true;
        } catch (error) {
            const error_explained = explainErrorTx(error);
            console.log(`[User] - handleBtnGetADATx - Error: ${error_explained}`);
            pushWarningNotification(WEBSITE_TITLE, error_explained);
            setProcessingTxMessage(error_explained);
            return false;
        }
    }

    public static async handleBtnGetTokenGovTx(
        setProcessingTxMessage: (value: string) => void,
        setProcessingTxHash: (value: string) => void,
        walletStore: IUseWalletStore,
        txParams: GetTokenGovTxParams
    ): Promise<boolean> {
        try {
            //--------------------------------------
            setProcessingTxMessage(`Sending ${TOKEN_GOV_TN_STR}...`);
            //--------------------------------------
            const { lucid, emulatorDB, walletTxParams } = await LucidToolsFrontEnd.prepareLucidFrontEndForTx(walletStore);
            //--------------------------------------
            const amount = txParams.amount;
            //--------------------------------------
            const tokenGov_AC_Lucid = TOKEN_GOV_CS + strToHex(TOKEN_GOV_TN_STR);
            const valueOf_TokenGov: Assets = { [tokenGov_AC_Lucid]: BigInt(amount) };
            console.log(`[User] - handleBtnGetTokenGovTx - valueOf_TokenGov: ${showData(valueOf_TokenGov)}`);
            //--------------------------------------
            const uTxOsAtWallet: UTxO[] = walletTxParams.utxos;
            if (uTxOsAtWallet.length === 0) {
                throw `Invalid uTxOsAtWallet length = 0`;
            }
            //--------------------------------------
            const uTxO: UTxO = uTxOsAtWallet[0];
            //--------------------------------------
            const assets: Assets = ((lucid.config().provider as any).ledger[uTxO.txHash + uTxO.outputIndex].utxo as UTxO).assets as Assets;
            ((lucid.config().provider as any).ledger[uTxO.txHash + uTxO.outputIndex].utxo as UTxO).assets = addAssets(assets, valueOf_TokenGov);
            //--------------------------------------
            pushSucessNotification(`User Get ${TOKEN_GOV_TN_STR} Tx`, 'aaff', true);
            //--------------------------------------
            setProcessingTxMessage(`Syncronizing...`);
            //--------------------------------------
            if (isEmulator && emulatorDB !== undefined) {
                // normalmente esto se hace en el submit, pero esta tx es mock y no hay submit
                await LucidToolsFrontEnd.syncEmulatorAfterTx(lucid, emulatorDB);
            }
            //--------------------------------------
            await walletStore.loadWalletData();
            //--------------------------------------
            return true;
        } catch (error) {
            const error_explained = explainErrorTx(error);
            console.log(`[User] - handleBtnGetTokenGovTx - Error: ${error_explained}`);
            pushWarningNotification(WEBSITE_TITLE, error_explained);
            setProcessingTxMessage(error_explained);
            return false;
        }
    }

    // #endregion front end Btn handlers
}
